import { render, staticRenderFns } from "./MultiPointPacketEditor.vue?vue&type=template&id=38b696cd&scoped=true&"
import script from "./MultiPointPacketEditor.vue?vue&type=script&lang=ts&"
export * from "./MultiPointPacketEditor.vue?vue&type=script&lang=ts&"
import style0 from "./MultiPointPacketEditor.vue?vue&type=style&index=0&id=38b696cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b696cd",
  null
  
)

export default component.exports